<div class="wrapper wrapper-medium">
  <!-- Back link -->
  <div class="back-link" (click)="navigateBack()">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="19" y1="12" x2="5" y2="12"></line>
      <polyline points="12 19 5 12 12 5"></polyline>
    </svg>
    <span>Back</span>
  </div>

  <!-- Loading indicator -->
  <div *ngIf="isLoading" class="loading-indicator">
    <loading message="loading user details..."></loading>
  </div>

  <!-- User details content -->
  <div *ngIf="!isLoading && user" class="user-detail-container">
    <!-- User header -->
    <div class="user-header flex-row flex-center-y margin-bottom-20">
      <div class="avatar-circle">
        <span class="initials">{{ user.FIRST_NAME.charAt(0) }}{{ user.LAST_NAME.charAt(0) }}</span>
      </div>
      <div class="header-detail">
        <h2>{{ user.FIRST_NAME }} {{ user.LAST_NAME }}</h2>
        <div class="user-role">{{ user.ROLE }}</div>
      </div>
    </div>

    <!-- Section tabs -->
    <div id="subnav-user-detail" class="subnav flex-row flex-center-y">
      <div class="tabs flex-row">
        <div *ngFor="let section of sections"
             class="tab"
             [class.active]="activeSection === section.id"
             (click)="navigateToSection(section.id)">
          <span>{{ section.label }}</span>
        </div>
      </div>
    </div>

    <!-- Section content -->
    <div class="section-content">
      <!-- General section -->
      <app-user-detail-general
        *ngIf="activeSection === 'general'"
        [user]="user">
      </app-user-detail-general>

      <!-- Households section -->
      <app-user-detail-households
        *ngIf="activeSection === 'households'"
        [user]="user">
      </app-user-detail-households>

      <!-- Files section -->
      <app-user-detail-files
        *ngIf="activeSection === 'files'"
        [user]="user">
      </app-user-detail-files>

      <!-- Access section -->
      <app-user-detail-access
        *ngIf="activeSection === 'access'"
        [user]="user">
      </app-user-detail-access>

      <!-- Activity section -->
      <app-user-detail-activity
        *ngIf="activeSection === 'activity' && userId !== null"
        [userId]="userId">
      </app-user-detail-activity>
    </div>
  </div>

  <!-- Error state -->
  <div *ngIf="!isLoading && !user" class="error-state">
    <div class="empty-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
    </div>
    <p class="error-message">User not found</p>
    <button class="btn btn-primary" (click)="navigateBack()">
      Go Back
    </button>
  </div>
</div>
